module.exports = __webpack_public_path__ + "media/images/color_admin_v3/transparent/black-0.6-4685c6a389000ee756f0e5564eab0c64.png";